import React from "react";
import './this.scss'

export default function Footer () {
    return <footer>
        © Toxi Woxi 2022-{new Date().getFullYear()}
    </footer>
}